import React, { useState, useContext } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./SigninAndSignup.css";
import { AuthContext } from "../../context/AuthContext";
import toast from "react-hot-toast";
import { storeInLocalStorage } from "../../Utils/LocalStorage";
import OTPInput from "react-otp-input";
import { Helmet } from "react-helmet-async";
import NavbarLogo from "../../Assets/Logo";

const SinginPage = () => {
  const location = useLocation();
  const redirectPath = new URLSearchParams(location.search).get("redirect");
  const { isAuthenticated, setIsAuthenticated, userId, setUserId } =
    useContext(AuthContext);

  const [signInData, setSignInData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const [showOtpPage, setShowOtpPage] = useState(false);
  const [otp, setOtp] = useState("");

  const inputEvent = (event) => {
    const { name, value } = event.target;
    setSignInData((preval) => ({
      ...preval,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const btn = document.getElementById("sign-in-btn");
    btn.classList.add("btn-click");
    setTimeout(() => {
      btn.classList.remove("btn-click");
    }, 300);
    console.log(signInData);
    // Define the fetch promise
    const myPromise = fetch(`${process.env.REACT_APP_BACKEND_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...signInData,
        device: 'web', // Always 'web' for web app, even when accessed from mobile browsers
      }),
    });

    // Use toast.promise for notifications
    toast
      .promise(
        myPromise.then(async (res) => {
          const data = await res.json();
          if (!res.ok) {
            throw new Error(data.error || "Login failed");
          }
          return data;
        }),
        {
          loading: "Signing in...",
          success: (data) =>
            data.IsOTPVerified
              ? "Login successful!"
              : "Verify your email to proceed.",
          error: (err) => err.message || "Failed to login.",
        }
      )
      .then((data) => {
        // Navigate to the homepage on successful login

        setUserId(data.USERID);
        setAccessToken(data.access_token);

        if (data.IsOTPVerified) {
          storeInLocalStorage({ user_id: data.USERID, access_token: data.access_token, email: signInData.email })
          if (redirectPath) {
            navigate(redirectPath);
          } else {
            navigate("/");
          }
          setIsAuthenticated(true);
        } else {
          setShowOtpPage(true);
          handleResendOTP(null, data.access_token);
        }
      })
      .catch(() => {
        // Run failure animation on error
        signinBtnFailedAnimation();
      });
  };
  const handleResendOTP = async (event, token) => {
    console.log(signInData);
    if (event) {
      event.preventDefault();
    }
    console.log(signInData);
    // Define the fetch promise
    const effectiveToken = token || accessToken;
    const myPromise = fetch(`${process.env.REACT_APP_BACKEND_URL}/resend_otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${effectiveToken}`,
      },
      body: JSON.stringify(signInData),
    });

    // Use toast.promise for loading, success, and error states
    toast
      .promise(
        myPromise.then(async (res) => {
          const response = await res.json();
          console.log(response);
          if (!res.ok) {
            setOtp("");
            throw new Error(response.message || "Failed to resend OTP");
          }
          return response; // Return the response data
        }),
        {
          loading: "Resending OTP...",
          success: `OTP sent to ${signInData.email}`,
          error: (err) => err.message || "Failed to resend OTP.",
        }
      )
      .then(() => {
        // Handle success case
        setShowOtpPage(true); // Show the OTP page again
      })
      .catch(() => {
        // Handle error case
        // signupBtnFailedAnimation(); // Run failed animation
      });
  };
  const handleVerifyOtp = async (event) => {
    event.preventDefault();
    const btn = document.getElementById("verify-otp-btn");
    btn.classList.add("btn-click");
    setTimeout(() => {
      btn.classList.remove("btn-click");
    }, 300);

    // Validation: Check if OTP is empty
    if (!otp) {
      toast.error("Enter OTP to proceed");
      return;
    }

    console.log(otp);

    // Define the fetch promise
    const myPromise = fetch(
      `${process.env.REACT_APP_BACKEND_URL}/verify_otp_signup`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Attach access token for authorization
        },



        
        body: JSON.stringify({ ...signInData, otp: otp }),
      }
    );

    // Use toast.promise to handle loading, success, and error states
    toast
      .promise(
        myPromise.then(async (res) => {
          const data = await res.json();
          if (!res.ok) {
            setOtp("");
            throw new Error(data.error || "OTP verification failed");
          }
          return data;
        }),
        {
          loading: "Verifying OTP...",
          success: "OTP verified successfully!",
          error: (err) =>
            err.message || "An error occurred during OTP verification.",
        }
      )
      .then((data) => {
        // Handle successful OTP verification
        if (redirectPath) {
          navigate(redirectPath);
        } else {
          navigate("/");
        }
        setIsAuthenticated(true);
        storeInLocalStorage({
          user_id: userId,
          access_token: accessToken,
          email:signInData.email
        });
        setShowOtpPage(false);
        setSignInData({
          email: "",
          password: "",
        });
      })
      .catch(() => {
        // Handle failure case
        const failedBtn = document.getElementById("verify-otp-btn");
        failedBtn.classList.add("shake-button"); // Add shake animation on failure
        setTimeout(() => {
          failedBtn.classList.remove("shake-button");
        }, 1000);
      }).finally(() => {
        setOtp("");
      })
  };



  const signinBtnFailedAnimation = () => {
    const failed = document.getElementById("sign-in-btn");
    setTimeout(() => {
      failed?.classList.add("shake-button");
    }, 500);
    setTimeout(() => {
      failed?.classList.remove("shake-button");
    }, 1000);
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    const pastedText = event.clipboardData.getData("text/plain");

    const input = event.target;
    const inputType = input.type; // Store the original input type
    input.type = "text"; // Temporarily change input type to "text"
    var newValue = value.substring(0, input.selectionStart) + pastedText;
    if (name !== "email") {
      newValue = newValue + value.substring(input.selectionEnd);
    }
    setSignInData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));

    // Change input type back to the original type
    input.type = inputType;

    // // Trigger the onChange event to update the state
    const changeEvent = new Event("input", { bubbles: true });
    input.dispatchEvent(changeEvent);
  };

  const googleLogin = async (event) => {
    event.preventDefault(); // Prevent any default behavior

    try {
      // Redirect the user directly to the backend endpoint
      // console.log(process.env.REACT_APP_GOOGLE_URL);
      window.location.href = `${process.env.REACT_APP_GOOGLE_URL}`;
    } catch (error) {
      console.error("Error during Google login initiation:", error);
      alert("An error occurred while trying to log in with Google.");
    }
  };


  return (
    <>

      {!isAuthenticated && (
        <>
          <Helmet>
            <title>
              IzzyAi.com • Login
            </title>
            <meta name="description"
              content="Log In to your IzzyAI Account. If you don't have an account yet, Sign Up and start discovering IzzyAI.com website."
            />
          </Helmet>
          <div
            className="outer-box pt-[80px] dark:bg-[#101920] flex justify-center items-center pb-30"
            id="signin-page"
          >
            <div className="inner-box mx-auto">
              {showOtpPage ? (
                <>
                  <div className="container">
                    <div className="row justify-content-md-center">
                      <div className="col-md-4 text-center">
                        <div className="row">
                          <div className="col-sm-12 mt-5 bgWhite otp-section">
                            <div className="flex items-center justify-center mb-6">
                              <NavbarLogo />
                            </div>
                            <h2 className="text-center text-xl font-bold mb-4 dark:text-white">Login</h2>
                            <p className="text-center text-gray-600 mb-4 dark:text-gray-200">Login to get started with IzzyAI</p>
                            <p className="text-center  text-gray-600 mb-6 dark:text-gray-200">
                              Enter the OTP sent to {signInData.email}
                            </p>
                            <OTPInput
                              value={otp}
                              onChange={setOtp}
                              numInputs={6}
                              containerStyle={{ justifyContent: "center" }}
                              renderInput={(props, index) => (
                                <input
                                  {...props}
                                  style={{
                                    display: "inline-block",
                                    width: "50px",
                                    height: "50px",
                                    textAlign: "center",
                                    border: "1px solid black",
                                    borderRadius: "4px",
                                    marginRight: "5px", // Optional: To add some space between the inputs
                                  }}
                                  className="focus:outline-none"
                                />
                              )}
                              placeholder="000000"
                              onPaste={handlePaste}
                            />
                            <hr className="mt-5 mb-1" />
                            <div className="flex justify-center">
                              <input
                                type="submit"
                                id="verify-otp-btn"
                                value="Verify"
                                onClick={handleVerifyOtp}
                                className="create-account button  focus:outline-none inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow h-10 px-4 w-full mt-6 rounded-full  bg-black text-white hover:bg-gray-800"
                              />
                            </div>

                            <footer className="signup-footer footer-in-singup">
                              <p className="text-sm text-gray-500 dark:text-gray-400">Didn't receive OTP?
                                <p onClick={handleResendOTP} className="hover:cursor-pointer marginDown hover:underline ml-2 text-blue-500">
                                  Resend OTP
                                </p>
                              </p>
                            </footer>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <header className="signup-header mb-4">
                    <div className="flex items-center justify-center mb-6">
                      <NavbarLogo />
                    </div>
                  </header>
                  <h2 className="text-center text-xl font-bold mb-4 dark:text-white">Login</h2>
                  <p className="text-center text-gray-600 mb-6 dark:text-gray-200">Login to get started with IzzyAI</p>
                  <main className="signup-body">
                    <form onSubmit={handleSubmit} className="form">
                      <p className="items-center mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300" htmlFor="email">Email <span className="text-red-500">*</span></label>
                        <input
                          type="email"
                          className="transition-colors focus-visible:ring-1 focus-visible:ring-ring placeholder:text-muted-foreground shadow-sm disabled:opacity-50 disabled:cursor-not-allowed dark:text-white flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                          id="email"
                          name="email"
                          placeholder="Enter your email here."
                          required=""
                          value={signInData.email}
                          onChange={inputEvent}
                          onPaste={handlePaste}
                        />
                      </p>
                      <div>
                        <label
                          className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300"
                          htmlFor="password"
                        >Password <span className="text-red-500">*</span>
                        </label>
                        <div className="mb-1">
                          <div className="relative">
                            <input
                              type={`${showPassword ? "text" : "password"}`}
                              className="dark:text-white flex h-9 rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 w-full pr-10"
                              id="password"
                              name="password"
                              placeholder="Enter your password here."
                              required value={signInData.password}
                              onChange={inputEvent}
                              onPaste={handlePaste}
                            />
                            <button type="button" className="absolute inset-y-0 right-0 px-3 flex items-center justify-end md:w-12 w-10" style={{ backgroundColor: "transparent" }}>
                              {
                                showPassword ? <svg onClick={() => setShowPassword(!showPassword)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="lucide lucide-eye h-5 w-5 text-gray-500 hover:text-gray-700 dark:text-gray-200 dark:hover:text-gray-300"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                  : <svg onClick={() => setShowPassword(!showPassword)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="lucide lucide-eye-off h-5 w-5 text-gray-500 hover:text-gray-700 dark:text-gray-200 dark:hover:text-gray-300"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"></path><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"></path><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"></path><path d="m2 2 20 20"></path></svg>
                              }

                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center mt-4">
                        <input
                          type="submit"
                          id="sign-in-btn"
                          value="Sign in"
                          className="create-account button  focus:outline-none inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow h-9 px-4 w-full mt-6 rounded-full  bg-black text-white hover:bg-gray-800"
                        />
                      </div>
                    </form>

                    <div className="mt-2 text-center">
                      <p className="text-sm text-gray-500 dark:text-gray-300">Forgot your password? <NavLink to="/forgotpassword" className="text-blue-500 hover:text-blue-700 hover:underline">Reset it</NavLink></p>
                    </div>
                    <div className="relative mt-6"><div className="absolute inset-0 flex items-center"><span className="w-full border-t"></span></div><div className="relative flex justify-center text-xs uppercase"><span className="bg-white px-2 text-gray-500">OR</span></div></div>

                    <div className="mt-6 flex justify-center space-x-4 bg-white dark:bg-[#101920]">
                      <button className=" inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 text-primary-foreground shadow w-36 h-12 p-0 rounded-full border border-gray-300 bg-white hover:bg-gray-200"
                        onClick={googleLogin}
                      >
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALDSURBVHgBrVZNaBNREJ55bxOqF+MfHlTcongSWbVKwYLbFm8e+uNFPDQ9F2x7keLFFhR6s72KUHuqBcHm5MUmC14qSI0Hb0IXsfQimoqlMdn3xtmNG5ufbRObDzYzzMx735s3894LQgMg2054ABYKYRKA/+UEoquVcuOOk91rPO7mLNq2jVI+ZNXiLxER5vIkMwWlUgccx22YZNu2zZiUc6za0DhcIJoy0unne5IUbNsSUmYgeuW7QhONx9PpmZ020UoCzsRVWi9Vm41Q8bdISvmK6hEQ5QDRYZlimSuZyOIVDhGiGRIUte6uV5fydnm9vX4NklALp6jUcFRRCz09Y0w2GkVQJtl+Dabx7twavj1T4dQA8/Hl5STsE0FNYnFu0y5ujsFPAIfyJQ+n3wqCMgnQ31Y9/w3o7seQaApaBKQMJDxl/Kgw5g3XuJVvrzfg6oOvltQ4Cg2iLV8YNzzPsKpPC7V5btQgqYm7D5PQILZisVlRz4GALrQIUlJCEHm5aociOgwthFAKakgEwg1oEZTCXFANb1muEaHp6xvqIDz6dQlWC8e739956UAT6JxYX2Nh7rStTJ/EoCaaMOXL1eJRGPl5neUxToeeQBO4dv9LXzUBt5Dj/wYkSLC0uH0WRja7gkxKfrA6FgcaIuqc2DCFkPVi58sksZueM7N1wakJIRy78mJwzlroMyEC1tPH/KDpTG0W/L5A0QmSKAfzRAbKD1DnFuYgl+8xB1ClUJcaRYMw+QkeYtXGwhEQn++BL/9BT61Mn56sIPHRsXDbDu6A/0BAtD4AuHkR/FqsTJ/qDn0Vh9HvJtLQz2oOmgTFv4Nqfwb6xJtsW77YX7GAegP8rZMoMnzyTWiGSMOs+q0ms8NLuT1JQlxeGEiG+x45MWeNyPXSOBt1rnYlCRFkRtJCJCu0afL/e4msl/ey1Suvxh/mzRvnpE22rAAAAABJRU5ErkJggg==" alt="Google Icon" className="h-6 w-6" />
                      </button>
                      {/* <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 text-primary-foreground shadow w-36 h-12 p-0 rounded-full border border-gray-300 bg-white hover:bg-gray-200">
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGVSURBVHgB1ZUxUgIxFIb/LM64OBavRKuUdmpnJ0fAzls4nkA4gXAC8QZ4AvcI3MBnI1QYG2cr48sOOCwku8NGC/8ZhpCXx5e8vLzXQoSINKVE1+kecZ6bPLQuQUPRkb5RbbwohYe6tY0gdKzvFDB0Q/lMjWHzqxDqaK0s+qvf1mJU57P7SRR6P0OLgZnzuM6lVWVcXmwnbZPOP83czaWHdCJfLjy3NsdE7Bdip5Xdv6/AnycHuJdQuF3Tcppl8eTL4ilJcCm2rsx119xYkmC8eONBLaSIucKzDDWaafo+4/P1ia07iQTAAo+bcyWI5H4vBlAkwoyHlRCUY7yreDHnvs+wCTlFU1lwyNS4rGwxFD7w1xBVEYUyxOIVzaUl/bv1ECBDhFxFdu+sGpJigjgVD3n5FPwQw2xs5GkcSMJOQUgheVCIE29W5i2ILMjkNLU9IiTr2aQ/hfeLpjTFjpI0Hvn6iwo5eKuxvOrizhRIHM/WbXKCDDmufK04CClAWpM4ropm5kJZsrsssgJT0udnHJuZ/0DfO2eB+H4HNIUAAAAASUVORK5CYII=" alt="Apple Icon" className="h-6 w-6" />
                      </button> */}
                    </div>
                  </main>


                  <div className="mt-4 text-center"><p className="text-sm text-gray-500 dark:text-gray-300">Don't have an account? <NavLink to="/signup" className="text-blue-500 hover:text-blue-700 hover:underline">Sign Up</NavLink></p></div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </>

  );
};

export default SinginPage;
